import { Container } from '../../components';
import styles from './platform.module.css';

export default function Platform() {
  return (
    <div className={styles.platform}>
      <Container>
        <div className={styles.platform_title}>Platform capabilities</div>
        <div className={styles.platform_inner}>
          <ul className={styles.platform_list}>
            <li className={styles.platform_item}>
              <ul className={styles.platform_secondList}>
                <li className={styles.platform_secondListItem}>Multiscreen</li>
                <li className={styles.platform_secondListItem}>Widhets</li>
                <li className={styles.platform_secondListItem}>Microphone</li>
              </ul>
            </li>
            <li className={styles.platform_item}>
              <ul className={styles.platform_secondList}>
                <li className={styles.platform_secondListItem}>
                  Fingerprint reader
                </li>
                <li className={styles.platform_secondListItem}>Camera APIs</li>
                <li className={styles.platform_secondListItem}>Geolocation</li>
              </ul>
            </li>
            <li className={styles.platform_item}>
              <ul className={styles.platform_secondList}>
                <li className={styles.platform_secondListItem}>Ads</li>
                <li className={styles.platform_secondListItem}>
                  In-app billing
                </li>
                <li className={styles.platform_secondListItem}>
                  Notifications
                </li>
                <li className={styles.platform_secondListItem}>
                  Motion sensors
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </Container>
    </div>
  );
}
